module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Book-WebXL-5ff3e28a9e234abc9abf28b32a444a35.woff2";